export * from './IconToolsHoldCurveHold';
